'use client';

import { useCallback } from 'react';
import { useRouter } from 'next/navigation';
// import { PriceEstimator2 } from '../../components';
import PriceEstimator from '../../components/PriceEstimator';
import BulkBookingBanner from '../../components/BulkBookingBanner';
// import PriceEstimator2 from '../../components/PriceEstimator2';
import { LayoutContainer } from '../../kit';
import ProtectedRoute from '../protectedRoute';
import { useBooking } from '../bookingContext';

export default function BookingPage() {
  const router = useRouter();
  const { setDetails } = useBooking();

  const onBookConsignment = useCallback(
    (bookingData) => {
      setDetails(bookingData);
      router.push('/summary');
    },
    [router, setDetails]
  );

  return (
    <ProtectedRoute>
      <LayoutContainer>
        <BulkBookingBanner />
        <PriceEstimator onBookConsignment={onBookConsignment} />
      </LayoutContainer>
    </ProtectedRoute>
  );
}
